import { Button, Text } from '@cloudflare/kumo'
import { useTranslation } from '../../i18n'

export function RegenerateSection({
  regenerating,
  onRequest,
}: {
  regenerating: boolean
  onRequest: () => void
}) {
  const { t } = useTranslation()
  return (
    <section className="flex flex-col items-start gap-2">
      <Text as="h2" variant="heading2">
        {t('wifi.trouble.title')}
      </Text>
      <Text variant="secondary">{t('wifi.trouble.description')}</Text>
      <Button
        variant="secondary-destructive"
        style={{ minHeight: 44 }}
        disabled={regenerating}
        loading={regenerating}
        onClick={onRequest}
      >
        {regenerating ? t('wifi.regenerating') : t('wifi.trouble.action')}
      </Button>
    </section>
  )
}
